(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-ajax"] && !Shopify.designMode) return;
  try {
    (function cartAjax() {
    const toast = document.querySelector('[data-cart-toast]');
    let hideTimer;

    function hide() {
      if (!toast) return;
      clearTimeout(hideTimer);
      toast.classList.remove('cart-ajax-toast--in');
      setTimeout(() => { toast.hidden = true; }, 250);
    }

    function say(message, isError) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.toggle('cart-ajax-toast--error', Boolean(isError));
      toast.hidden = false;
      requestAnimationFrame(() => toast.classList.add('cart-ajax-toast--in'));
      clearTimeout(hideTimer);
      /* Errors sit centred over the page, so give them longer to be read than
         a success confirmation. */
      hideTimer = setTimeout(hide, isError ? 5000 : 2600);
    }

    /* Centred means it covers content, so it must be dismissible rather than
       something the shopper waits out. */
    if (toast) {
      toast.addEventListener('click', hide);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !toast.hidden) hide();
      });
    }

    function refreshCount() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
        });
    }

    /* Delegated, so cards rendered later (filtering, pagination) are covered
       without rebinding. */
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('.pdp__form, .product-card__form');
      if (!form) return;

      /* Let the dynamic checkout button ("Buy it now") through to checkout.
         Only bail on a submitter we can positively identify as that button —
         an earlier version bailed on any submitter not named "add", so a
         plain unnamed card button fell through to a full page post. */
      const submitter = e.submitter;
      if (
        submitter &&
        (submitter.classList.contains('shopify-payment-button__button') ||
          submitter.closest('.shopify-payment-button'))
      ) {
        return;
      }

      e.preventDefault();

      const btn = form.querySelector('[name="add"], button[type="submit"]');
      if (btn && btn.disabled) return;

      /* Only the cart fields. Shopify's product form also emits form_type and
         utf8; posting those to /cart/add.js makes it answer with an HTML page
         instead of JSON. */
      const idField = form.querySelector('[name="id"]');
      const qtyField = form.querySelector('[name="quantity"]');
      const payload = new URLSearchParams();
      payload.set('id', idField ? idField.value : '');
      payload.set('quantity', qtyField ? qtyField.value || '1' : '1');

      const original = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: payload
      })
        .then((res) =>
          res
            .json()
            .catch(() => ({}))
            .then((data) => ({ ok: res.ok, data }))
        )
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || data.message || '');
          return refreshCount().then(() => {
            say(toast ? toast.getAttribute('data-label-added') : '', false);
          });
        })
        .catch((err) => {
          say(err.message || (toast ? toast.getAttribute('data-label-error') : ''), true);
        })
        .finally(() => {
          if (!btn) return;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = original;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    class LocalizationSwitcher extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-lang-toggle]');
      this.list = this.querySelector('[data-lang-list]');
      if (!this.toggle || !this.list) return;

      this.onDocClick = (e) => {
        if (!this.contains(e.target)) this.close();
      };

      this.toggle.addEventListener('click', () => {
        if (this.list.hasAttribute('hidden')) this.open();
        else this.close();
      });

      // Escape closes and returns focus to the trigger, so keyboard users are
      // not stranded inside a dismissed popover.
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.list.hasAttribute('hidden')) {
          this.close();
          this.toggle.focus();
        }
      });
    }

    open() {
      this.list.removeAttribute('hidden');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this.onDocClick);
    }

    close() {
      this.list.setAttribute('hidden', '');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onDocClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
    }
  }

  if (!customElements.get('localization-switcher')) {
    customElements.define('localization-switcher', LocalizationSwitcher);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-card-gallery]').forEach((card) => {
    const imgs = card.querySelectorAll('.card-gal__img');
    if (imgs.length < 2) return;
    const dots = card.querySelectorAll('[data-gal-dot]');
    const link = card.querySelector('[data-card-media]');
    let cur = 0;

    const go = (i) => {
      cur = ((i % imgs.length) + imgs.length) % imgs.length;
      imgs.forEach((im, x) => im.classList.toggle('card-gal__img--active', x === cur));
      dots.forEach((d, x) => d.classList.toggle('card-gal__dot--active', x === cur));
    };
    card.classList.add('card-gal--init');
    go(0);

    card.querySelector('[data-gal-prev]').addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(cur - 1); });
    card.querySelector('[data-gal-next]').addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); go(cur + 1); });

    let startX = null;
    let swiped = false;
    link.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; swiped = false; }, { passive: true });
    link.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      swiped = true;
      go(dx > 0 ? cur - 1 : cur + 1);
    }, { passive: true });
    /* a swipe must not follow the link */
    link.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); swiped = false; } });
  });
  } catch(e) { console.error(e); }
})();

})();
